import { render, staticRenderFns } from "./YtInputNumber.vue?vue&type=template&id=c087a6f4&scoped=true&"
import script from "./YtInputNumber.vue?vue&type=script&lang=js&"
export * from "./YtInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./YtInputNumber.vue?vue&type=style&index=0&id=c087a6f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c087a6f4",
  null
  
)

export default component.exports